var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "register-page" }, [
    _vm._m(0),
    _c("div", { staticClass: "form-container" }, [
      _c("div", { staticClass: "form-content" }, [
        _c("div", { staticClass: "form-item" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.phone,
                expression: "data.phone"
              }
            ],
            attrs: {
              placeholder: "请输入手机号",
              type: "tel",
              maxlength: "11"
            },
            domProps: { value: _vm.data.phone },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "phone", $event.target.value)
              }
            }
          })
        ]),
        _c("div", { staticClass: "form-item sms" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.code,
                expression: "data.code"
              }
            ],
            attrs: { placeholder: "请输入验证码", type: "tel", maxlength: "4" },
            domProps: { value: _vm.data.code },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "code", $event.target.value)
              }
            }
          }),
          _vm.showCode
            ? _c("button", { on: { click: _vm.getSms } }, [
                _vm._v("获取验证码")
              ])
            : _c("button", [_vm._v(_vm._s(_vm.counts) + "s重新发送")])
        ]),
        _c(
          "div",
          { staticClass: "protocol" },
          [
            _c("van-checkbox", {
              attrs: { "checked-color": "#F4512B", "icon-size": "13px" },
              model: {
                value: _vm.checked,
                callback: function($$v) {
                  _vm.checked = $$v
                },
                expression: "checked"
              }
            }),
            _vm._m(1)
          ],
          1
        ),
        _c("div", { staticClass: "btn", on: { click: _vm.login } }, [
          _vm._v(" 接受邀请 ")
        ])
      ])
    ]),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "register-header" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/imgs/invitationPage/zhubiao@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请阅读并同意 "),
      _c(
        "a",
        {
          attrs: {
            href: "https://protocol.imlaw.cn/lawyer_user_protocol.html?header=0"
          }
        },
        [_vm._v("《法临注册协议》")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pictures" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/imgs/invitationPage/tab2@2x.png"),
          alt: ""
        }
      }),
      _c("img", {
        attrs: {
          src: require("@/assets/imgs/invitationPage/tab3@2x.png"),
          alt: ""
        }
      }),
      _c("img", {
        attrs: {
          src: require("@/assets/imgs/invitationPage/tab4@2x.png"),
          alt: ""
        }
      }),
      _c("img", {
        attrs: {
          src: require("@/assets/imgs/invitationPage/tab5@2x.png"),
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }